<template>
  <div class="viewport-details-panel panel-primary">
    <div class="header-box">
      <div class="title-box">视口详情</div>
      <div class="close-icon-box" @click="closePanel">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="content-box">
      <div class="item-box">
        <div class="label-box">视口名称：</div>
        <div class="value-box">{{ viewportDetails.name }}</div>
      </div>
      <div class="item-box">
        <div class="label-box">创建人：</div>
        <div class="value-box">
          {{ viewportDetails.creatorName ? viewportDetails.creatorName : "--" }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">创建时间：</div>
        <div class="value-box">
          {{ formatTime(viewportDetails.creationTime) }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">视口描述：</div>
        <div class="value-box muti-line-box">
          {{ viewportDetails.description ? viewportDetails.description : "--" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from "@/utils/generalMethods";

export default {
  props: {
    viewportDetails: Object,
    closeViewportDetailsPanel: Function,
  },
  methods: {
    closePanel() {
      this.closeViewportDetailsPanel();
    },
    formatTime,
  },
};
</script>

<style lang="less" scoped>
.viewport-details-panel {
  position: absolute;
  left: -50%;
  transform: translate(-50%, 50%);
  margin-left: -10px;
  width: 100%;
  z-index: 3;

  .header-box {
    cursor: default;
  }

  .content-box {
    padding: 16px;
    font-size: 14px;
    color: var(--default-color);

    .item-box {
      display: flex;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .label-box {
        width: 80px;
        text-align: right;
        flex-shrink: 0;
      }

      .value-box {
        word-break: break-all;
        text-align: left;
      }

      .muti-line-box {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        line-height: 1.5em;
        max-height: 100px;
        overflow-y: auto;
      }
    }
  }
}
</style>